import { Grid } from '@material-ui/core';
import React from 'react';
import { EJRecordTypes } from '../../common/enumerations/ej-record-types';
import transactionSavedImage from '../media/transaction_saved.svg';
import { styles } from './action-window-styles';
import { useTranslation } from 'react-i18next';

const ProductVoidedItem: React.FC<Props> = (props: Props): JSX.Element => {
  const { isKeypadVisible, itemType } = props;
  const classes = styles({});
  const { t } = useTranslation();

  return (
    <div className='fullWidth'>
      <Grid
        item
        xs={isKeypadVisible ? 10 : 12}
        className={classes.productVoidedText}
        data-testid='product-voided-text'
      >
        <span className={classes.superText}>{getVoidMessage(t, itemType)}</span>
      </Grid>
      <Grid item xs={isKeypadVisible ? 10 : 12}>
        <img
          src={transactionSavedImage}
          alt='Product Voided'
          className={classes.productVoidedImage}
        />
      </Grid>
    </div>
  );
};

interface Props {
  isKeypadVisible: boolean | undefined;
  itemType: string | undefined;
}

export default ProductVoidedItem;

const getVoidMessage = (t, itemType?: string): string => {
  switch (itemType) {
    case EJRecordTypes.Promotion:
    case EJRecordTypes.RewardAsTender:
      return t('ItemView_PromotionVoided');
    case EJRecordTypes.Coupon:
      return t('ItemView_CouponVoided');
    case EJRecordTypes.Tender:
      return t('ItemView_TenderVoided');
    case EJRecordTypes.CustomerItemInfo:
      return t('Item_Removed');
    default:
      return t('ItemView_ProductVoided');
  }
};
